/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyDiagnosticsMetadata
 */
export interface PropertyDiagnosticsMetadata {
    /**
     * 
     * @type {number}
     * @memberof PropertyDiagnosticsMetadata
     */
    vervotechPropertyId?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyDiagnosticsMetadata
     */
    propertyName?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDiagnosticsMetadata
     */
    chainName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyDiagnosticsMetadata
     */
    premiumBrand?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PropertyDiagnosticsMetadata
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyDiagnosticsMetadata
     */
    country?: string;
}

/**
 * Check if a given object implements the PropertyDiagnosticsMetadata interface.
 */
export function instanceOfPropertyDiagnosticsMetadata(value: object): value is PropertyDiagnosticsMetadata {
    return true;
}

export function PropertyDiagnosticsMetadataFromJSON(json: any): PropertyDiagnosticsMetadata {
    return PropertyDiagnosticsMetadataFromJSONTyped(json, false);
}

export function PropertyDiagnosticsMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyDiagnosticsMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'] == null ? undefined : json['vervotech_property_id'],
        'propertyName': json['property_name'] == null ? undefined : json['property_name'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'premiumBrand': json['premium_brand'] == null ? undefined : json['premium_brand'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function PropertyDiagnosticsMetadataToJSON(json: any): PropertyDiagnosticsMetadata {
    return PropertyDiagnosticsMetadataToJSONTyped(json, false);
}

export function PropertyDiagnosticsMetadataToJSONTyped(value?: PropertyDiagnosticsMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'property_name': value['propertyName'],
        'chain_name': value['chainName'],
        'premium_brand': value['premiumBrand'],
        'city': value['city'],
        'country': value['country'],
    };
}

